import { Children, type JSX } from 'react';

import { isEmptyFragment, nodeHasRenderableContent } from '../../util/elements';

import { type Action, type ActionsProp } from './types';

export const pruneActions = (actions?: ActionsProp): JSX.Element[] =>
  Children.toArray(actions).filter(
    (action): action is JSX.Element =>
      Boolean(action) && !isEmptyFragment(action) && nodeHasRenderableContent(action),
  );

export const willActionsRender = (actions?: ActionsProp): boolean =>
  pruneActions(actions).length !== 0;

export const mergeActions = (
  action?: ActionsProp,
  ...actions: ActionsProp[]
): ActionsProp | undefined => {
  const flattened = [action, ...actions].reduce(
    (acc: Action[], act) => (Array.isArray(act) ? [...acc, ...act] : [...acc, act]),
    [],
  );
  return flattened.length === 1 ? flattened[0] : flattened.length === 0 ? undefined : flattened;
};
